import { connect } from 'react-redux';
import { likeComment, unlikeComment } from '../../redux/actionCreators';
const mapDispatchToProps = {
    onLike: likeComment,
    onUnlike: unlikeComment
};
export default connect(null, mapDispatchToProps);

//# sourceMappingURL=LikeButton.container.js.map